/**
 * useMemberManagementConfig
 * ---------------------------------------------------------------------------
 * Centralise les variations de configuration UI/Action entre les rôles
 * (cooper / admin / super_admin) qui partagent le composant
 * CooperMembresManagement.js. Évite la dispersion de conditions
 * `if (user?.role === 'cooper') { ... }` dans le JSX.
 *
 * Ajouter ici toute future différentiation d'options selon le rôle.
 */
import { useMemo } from 'react';
import { Calculator, Home, Sparkles } from 'lucide-react';
import React from 'react';

const SIMULATOR_IA_ACTIVITES = {
  id: 'ia-activites',
  nom: 'Simulateur IA activités',
  description: 'Sélection IA des activités BTP puis contribution + CP/CG',
  icon: <Sparkles className="h-6 w-6 text-violet-600" />,
  path: '/calculateur-batico',
  color: 'violet',
  ia: true,
};

const SIMULATOR_BATICO = {
  id: 'batico',
  nom: 'Garantie RCDS BATICO',
  description: 'Simulateur de garantie Responsabilité Civile Décennale Solidaire',
  icon: <Calculator className="h-6 w-6 text-amber-500" />,
  path: '/calculateur-batico',
  color: 'amber',
};

const SIMULATOR_DOS = {
  id: 'dos',
  nom: 'DOS-DOMIUM',
  description: "Dommages-Ouvrage Solidaire pour habitat individuel",
  icon: <Home className="h-6 w-6 text-orange-500" />,
  path: '/simulateur-dos',
  color: 'orange',
};

export function useMemberManagementConfig(role) {
  return useMemo(() => {
    const normalizedRole = (role || 'cooper').toLowerCase();
    const isCooperOnly = normalizedRole === 'cooper';
    const isAdminLevel = ['admin', 'super_admin', 'expert'].includes(normalizedRole);

    return {
      role: normalizedRole,
      isCooperOnly,
      isAdminLevel,
      // Liste des simulateurs proposés dans le picker "Estimation rapide"
      simulators: isCooperOnly
        ? [SIMULATOR_IA_ACTIVITES, SIMULATOR_BATICO]
        : [SIMULATOR_IA_ACTIVITES, SIMULATOR_BATICO, SIMULATOR_DOS],
      // Capacités fines (extensibles)
      canDeleteMember: normalizedRole === 'super_admin',
    };
  }, [role]);
}

export default useMemberManagementConfig;
